import { faPlus, faWavePulse } from "@fortawesome/pro-regular-svg-icons";

import { SELECT_DIVIDER, Select } from "src/base-components/Select";
import { useDatasets } from "src/datasets/api/queries";
import { Icon } from "src/design-system/Icon";
import { useFlowContext } from "src/router/routerContextHooks";

type Props = {
  selectedDataset?: string | null;
  onCreateDataset?: () => void;
  onSelectDataset?: (value: string | null) => void;
};

export const SelectDatasetDropdown: React.FC<Props> = ({
  selectedDataset,
  onCreateDataset,
  onSelectDataset,
}) => {
  const { workspace, flow } = useFlowContext();
  const { data: allDatasets, isLoading } = useDatasets({
    flowId: flow.id,
    baseUrl: workspace.base_url,
  });

  const simulationDatasets =
    allDatasets?.filter((dataset) => dataset.purpose === "simulation") || [];

  const datasetOptions = simulationDatasets.map((dataset) => ({
    key: dataset.id,
    value: (
      <div className="flex items-center">
        <Icon icon={faWavePulse} size="xs" variant="active" />
        <span className="ml-2">{dataset.name}</span>
      </div>
    ),
  }));

  const options = [
    ...datasetOptions,
    ...(datasetOptions.length > 0 ? [SELECT_DIVIDER] : []),
    {
      key: "create-dataset",
      value: (
        <div className="flex items-center">
          <Icon icon={faPlus} size="xs" />
          <span className="ml-2">Create dataset</span>
        </div>
      ),
    },
  ];

  const handleSelectChange = (value: string) => {
    if (value === "create-dataset") {
      onCreateDataset?.();
    } else {
      onSelectDataset?.(value ?? null);
    }
  };

  return (
    <div className="flex w-full">
      <Select
        dataLoc="select-sim-dataset-dropdown"
        loading={isLoading}
        options={options}
        placeholder={
          datasetOptions.length === 0
            ? "No simulation datasets available"
            : "No dataset selected"
        }
        value={selectedDataset}
        fullWidth
        onChange={handleSelectChange}
      />
    </div>
  );
};
